export default __webpack_public_path__ + "static/media/variety-indian-food.81400d55.jpeg";